import React, { FC } from 'react'

// Components
import { Modal } from 'components/shared'

// Styles
import { makeStyles, Theme, Box, IconButton, Typography } from '@material-ui/core'

// Types
import { GameFlowSteps } from '../../types'

// Images
import CloseIcon from '@material-ui/icons/Close'

interface AboutProps {
  eventDate?: string
  eventDescription?: string
  showModal: boolean
  setShowModal: (boolean) => void
}

export const About: FC<AboutProps> = ({
  setShowModal,
  showModal,
  eventDate = '24 November at 2PM GMT (3 PM CET)',
  eventDescription = `During this virtual customer event, we will bring together experts from Verizon and groundbreaking companies to explore the role of private 5G in business.<br/><br/>With illuminating speakers, informative demos, and breakout sessions covering a variety of languages and verticals, you’ll learn that 5G can be a killer platform for innovation if it’s secured right, integrated right, and managed right.<br/><br/>This is the 5G platform business has been waiting for. This is 5G built right.`
}) => {
  const classes = useStyles()

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)}>
      <Box className={classes.root}>
        <IconButton
          className={classes.closeButton}
          color='default'
          aria-label='close'
          onClick={() => setShowModal(false)}
        >
          <CloseIcon fontSize='large' />
        </IconButton>
        <Typography component='h1' variant='h4' color='textPrimary' gutterBottom>
          5G Ready: Built Right for Business with Verizon
        </Typography>
        <Typography component='h6' variant='h6' color='textPrimary' gutterBottom>
          {eventDate}
        </Typography>
        <Typography
          component='p'
          variant='body1'
          color='textPrimary'
          gutterBottom
          dangerouslySetInnerHTML={{ __html: eventDescription }}
        />
      </Box>
    </Modal>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '560px',
    borderRadius: 0,
    margin: '0 auto',
    position: 'relative',
    padding: '58px 52px 38px',
    backgroundColor: '#ffffff',

    [theme.breakpoints.only('xs')]: {
      width: '100%',
      padding: '20px'
    }
  },
  closeButton: {
    position: 'absolute',
    top: '0',
    right: '0'
  }
}))
